import sanityClient from '@sanity/client'

export default sanityClient({
  projectId: "nlfjloli",
  dataset: "production"
})